import $api from "../../../http/slotProviders"

class SlotsProviders {
    static searchSlots(name,category_games) {
        return $api.post("/searchSlots", {name,category_games})
    }
    static unlike_slot(gameCode,category_games){
        return $api.post("/unlikeSlot",{gameCode,category_games})
    }
    static like_slot(gameCode,category_games){
        return $api.post("/likeSlot",{gameCode,category_games})
    }
    static getAll(category_games,most_five=null) {
        return $api.post("/getAll",{most_five,category_games});
    }

    static getGameUrl(gameCode,mode="demo") {

        return $api.post("/enter_game", {
        data:{game_uuid:gameCode},mode
        })
    }
}

export default SlotsProviders